import { useState, useEffect } from 'react';
import './App.css';
import GPSData from './Components/main_map';
import Navbar from './Components/screens/navbar';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import JourneySoFar from './Components/journeysofar';
import TeamStructure from './Components/team';
import Sponsors from './Components/sponsors';
import Loading from './Components/Loading';

function App() {
  const [navhead, setnavhead] = useState(`IITD ShuttleTrack`);
  const [isLoading, setIsLoading] = useState(window.location.hash === "");
  useEffect(() => {
    // Simulate a loading delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500); // 3-second delay

    return () => {
      clearTimeout(timer);
    };
  }, []);
  useEffect(() => {
    const updateNavhead = () => {
      let pathname = window.location.hash;
      console.log(pathname);
      if (pathname === '/' || pathname === '') {
        setnavhead('IITD ShuttleTrack')
      }
      else if (pathname === '#/Live_Location') {
        setnavhead('IITD ShuttleTrack')
      }
      else if (pathname === '#/Bus_Schedule') {
        setnavhead('Bus Schedule')
      }
      else if (pathname === '#/About_Us') {
        setnavhead('Our Team')
      }
      else if (pathname === '#/Journey_so_far') {
        setnavhead('Our Journey')
      }
      else if (pathname === '#/Bus_stops') {
        setnavhead('Bus Stops')
      }
      else if (pathname === '#/Benefactors') {
        setnavhead('Pillars of Support')
      }
    };
    // Update navhead on initial render
    updateNavhead();

    // Add event listener for hash changes
    window.addEventListener('hashchange', updateNavhead);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('hashchange', updateNavhead);
    };
  }, []);

  const [darkmode, setdarkmode] = useState(false);

  return (
    <>
      {isLoading && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 255, 1)", // Semi-transparent background
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999, // Ensure it's above everything
        }}>
          <Loading />
        </div>
      )}
      <div
        className="App"
        style={{
          backgroundColor: darkmode ? "#2B202A" : "white",
          color: darkmode ? "white" : "black",
          marginTop: "0px",
          paddingTop: "9px",
          opacity: isLoading ? 0 : 1, // Hide when loading
          transition: "opacity 1.5s ease-in-out" // Smooth fade-in effect
        }}
      >
        <Navbar heading={navhead} darkmode={darkmode} />
        <Router>
          {/* <CollapsibleSidebar /> */}
          <div style={{ marginLeft: '2%', marginRight: '2%' }}>
            <Routes>
              <Route exact path='/' element={<GPSData setDarkmode={setdarkmode} darkmode={darkmode} />} />
              <Route exact path='/Live_Location' element={<GPSData setDarkmode={setdarkmode} darkmode={darkmode} />} />
              {/* <Route exact path='/Bus_Schedule' element={<iframe title='bus_sch' className='pdf' src={require('./Components/screens/Bus_Schedule.pdf')} width={'90%'} style={{ marginTop:'4vh',height:'80vh'}}/>}/> */}
              <Route exact path='/Bus_Schedule' element={<object
                data={require('./Components/screens/Bus_Schedule.pdf')}
                type="application/pdf"
                frameBorder="0"
                width="100%"
                height="650vh"
                style={{ padding: "20px" }}
              >
                <div style={{ marginTop: '50vh', display: "inline", justifyContent: "center" }}>
                  <img
                    src={require('./Components/screens/Bus_Schedule_pg1.jpg')}
                    alt="Bus Schedule"
                    width="400vw"
                    style={{ marginLeft: "0.5vw", display: "block", float: "left" }}
                  />
                  <img
                    src={require('./Components/screens/Bus_Schedule_pg2.jpg')}
                    alt="Bus Schedule"
                    width="400vw"
                    style={{ marginLeft: "0", display: "block", float: "left" }}
                  />
                </div>
              </object>} />
              <Route exact path='/About_Us' element={<TeamStructure />} />
              <Route exact path='/Journey_so_far' element={<JourneySoFar />} />
              <Route exact path='/Bus_stops' element={<img className='busstops' src={require('./Components/screens/bus_route.jpeg')} alt='bus_route_map' />} />
              <Route exact path='/Benefactors' element={<Sponsors />} />
              {/* <Route path='*' element={<GPSData />}/> */}
            </Routes>
          </div>
        </Router>
      </div>
    </>
  );
}

export default App;
